// components/Header.js
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

function Header({ showBack, title = '', subtitle = '', showProfile }) {
  const navigate = useNavigate();

  return (
    <header className="section-header">
      {/* Back Button */}
      {showBack && (
        <button className="back-btn" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} className="text-lg" />
        </button>
      )}

      {/* Title and Subtitle */}
      {title && (
        <div>
          <h1 className="app-title">{title}</h1>
          {subtitle && <p className="subtitle">{subtitle}</p>}
        </div>
      )}

      {/* Profile Button */}
      {showProfile && (
        <button className="profile-btn" onClick={() => navigate('/profile')}>
          <FontAwesomeIcon icon={faUserCircle} />
        </button>
      )}
    </header>
  );
}

export default Header;